export const API_ENDPOINTS = {
  appConfiguration: 'app-configuration',
  authorization: 'authorization/v1',
  claims: 'claims/v1',
  sizesUrl: 'sizes/v1',
  encryptedAgGridLicensekey: 'api/aggrid-licensekey',
  companyFinancialUrl: 'companyfinancials/v1',
  catalogUrl: 'catalog/v1',
  sharesUrl: 'shares/v1',
  preferenceUrl: 'preference/v1'
};

export const HYDRA_ENTITY_CODES = {
  LANGUAGE_PARENT: '4fa300f2-e086-4f0b-9162-fe7239ab7312'
};
